Cm.instagram = {
    init() {
        if ($('.instagram-post-wrapper').length) {
            $('.instagram-post-wrapper').each( function() {
                var _this = $(this);

                _this.html(_this.data('loading'));

                var xhttp = new XMLHttpRequest();
                xhttp.onreadystatechange = function() {
                    var temp = '<ul class="list-posts list-unstyled">';
                    if (this.readyState == 4 && this.status == 200) {
                        var record = JSON.parse(this.responseText);

                        if (record && record.graphql && record.graphql.user && record.graphql.user.edge_owner_to_timeline_media) {
                            for (let i = 0; i < record.graphql.user.edge_owner_to_timeline_media.edges.length; i++) {
                                const post = record.graphql.user.edge_owner_to_timeline_media.edges[i].node;
                                temp += (`<li>
                                        <a style="background-image: url('__BG__');" class="d-block" href="__LINK__" target="_blank" alt="">
                                            <p class="addon-display position-absolute justify-content-center align-items-center __ADDON_CLASS__">
                                                <small class="d-block">
                                                    <span class="likes"><i></i>__LIKES__</span> 
                                                    <span class="comments"><i></i>__COMMENTS__</span>
                                                </small>
                                            </p>
                                        </a>
                                    </li>`)
                                    .replace('__LINK__', 'https://www.instagram.com/p/' + post.shortcode)
                                    .replace('__ADDON_CLASS__', _this.data('buttonBadge') ? '' : 'd-none')
                                    .replace('__LIKES__', post.edge_liked_by.count)
                                    .replace('__COMMENTS__', post.edge_media_to_comment.count)
                                    .replace('__BG__', post.thumbnail_src);
                            }
                        }

                        temp += `</ul><div class="cat-section d-block">
                                <a href="__LINK__" target="_blank" class="btn-default-black d-inline-block">
                                    __LABEL__
                                </a>
                            </div>`
                            .replace('__LINK__', _this.data('buttonLink'))
                            .replace('__LABEL__', _this.data('buttonLabel'));

                        _this.html(temp);
                    }
                };
                xhttp.open("GET", "https://instagram.com/camdenmarketldn/?__a=1", true);
                xhttp.send();

            });            
        }
    }
};